import { Unit, BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
import { Hour } from "./duration";
// Per Duration
export var OnePerHour = UnitDivide.dimensionlessByDuration("OnePerHour", Unit.One, Hour);
export var OnePerSecond = UnitDivide.dimensionlessByDuration("OnePerSecond", Unit.One, BaseUnits.Second);
//# sourceMappingURL=dimensionless-per-duration.js.map